import { render } from "./SelectorAddress.vue?vue&type=template&id=a5f015ba"
import script from "./SelectorAddress.vue?vue&type=script&lang=js"
export * from "./SelectorAddress.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__